export class JuridicaDeclaracion {

    model = {
        acepta_declaracion: {
            value: false,
            header: 'Acepta',
            required: 'Es requerido'
        },
        observacion: {
            value: '',
            header: 'Observación:',
            required: 'Observación es requerido',
            maxLength: 'Máximo 1000 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 1000,
            min: 4,
        },
        descripcion_transaccion: {
            value: '',
            header: 'Describa la transacción u operación que realiza con la compañía:',
            required: 'Descripción de la transacción es requerido',
            maxLength: 'Máximo 250 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 250,
            min: 4,
        },
        monto: {
            value: '',
            header: 'Monto total de la transacción u operación:',
            required: 'Monto es requerido',
            maxLength: 'Máximo 99999999.99',
            minLength: 'Mínimo 0',
            max: 99999999.99,
            min: 0,
        },
        moneda: {
            value: null,
            header: 'Moneda:',
            required: 'Moneda es requerido'
        },
        fecha_transaccion: {
            value: null,
            header: 'Fecha de la transacción u operación (día/mes/año):',
            required: 'Fecha de la transacción es requerido'
        },
        pais_pago: {
            value: null,
            header: 'País donde proviene el pago:',
            required: 'País de pago es requerido'
        },
        provincia_pago: {
            value: null,
            header: 'Provincia donde proviene el pago:',
            required: 'Provincia de pago es requerido'
        },
        ciudad_pago: {
            value: null,
            header: 'Ciudad donde proviene el pago:',
            required: 'Ciudad de pago es requerido'
        },
        canton_pago: {
            value: '',
            header: 'Ciudad donde proviene el pago:',
            required: 'Ciudad de pago es requerido',
            maxLength: 'Máximo 100 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 100,
            min: 4,
        },
        valor_fuente: {
            value: '',
            header: 'Los valores entregados provienen de la siguiente actividad económica o fuente:',
            required: 'Fuente es requerido',
            maxLength: 'Máximo 250 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 250,
            min: 4,
        },
        valor_entregado: {
            value: null,
            header: 'Los valores entregados o por entregar son:',
            required: 'Valor entregado es requerido'
        }
    }
    optionLabel = 'nombre';
    strDeclara = <>Declaro bajo juramento que:<ul><li>La información registrada en el presente documento y la documentación que se acompaña es fidedigna y asumo cualquier responsabilidad
        por los daños que pudiere sufrir la Compañía a la que declaro esta información por la eventual falsedad o imprecisión de esta; y,</li>
        <li>La información económica y patrimonial registrada cuenta con todos los sustentos que corresponden.</li></ul>
        <p>Finalmente, autorizo expresamente a  realizar el análisis y las verificaciones que se consideren pertinentes a la información suministrada y aquella que obtenga la compañía a la que
        declaro; y, en el caso de detectarse alguna inusualidad, informar de manera inmediata y documentada a las autoridades competentes.</p></>;
    strAutorizacionTratamientoDatos = <>
        <ol style={{ paddingLeft: "13px", }}>
            <li>El Responsable de los Datos Personales ha puesto en mi conocimiento su Política de Tratamiento de Datos Personales, la misma que me ha sido entregada y que consta en su página web. En ella constan los principios, cuidados y derechos respecto al tratamiento de mis datos personales.</li>
            <br />
            <li>De conformidad con el art. 8 de la Ley Orgánica de Protección de Datos Personales y art. 5 de su Reglamento, con la suscripción del presente formulario, consiento de manera libre, previa, expresa, voluntaria, y debidamente informada al Responsable de los Datos Personales, para que realice el tratamiento de mis datos personales en calidad de responsable. Entiendo que mis datos personales podrán ser compartidos con terceros, en concordancia con las disposiciones legales.</li>
            <br />
            <li>El Responsable de los Datos Personales declara que el tratamiento de datos personales se realizará dentro de los límites y de conformidad y con fundamento en lo dispuesto en el Art. 66 nº 19 de la Constitución de la República, la Ley Orgánica de Prevención, Detección y Combate del Delito de Lavado de Activos y de la Financiación de Otros Delitos y la LOPDP. El Responsable tratará mis datos personales con reserva y ha adoptado las medidas técnicas y organizativas necesarias para garantizar su seguridad, integridad y confidencialidad.</li>
            <br />
            <li>Los datos y documentación que aporto mediante el presente formulario son veraces y exactos, y el Responsable podrá efectuar las validaciones que considere pertinentes.</li>
            <br />
            <li>Autorizo al Responsable de los Datos Personales a contactarme y enviarme comunicaciones por cualquier medio, teniendo en consideración la finalidad antes expresada. Asimismo, podré comunicarme con el Responsable en cualquier momento si tengo preguntas o solicitudes sobre el tratamiento de mis datos personales.</li>
        </ol>
    </>;
    strDifare = <><ol>
        <li>Autorizo a la Compañía el tratamiento de mis datos personales con la finalidad de permitir que la entidad responsable del tratamiento de datos pueda llevar a cabo todas las acciones necesarias para la prevención, detección, investigación y control de actividades relacionadas con el lavado de activos y el financiamiento del terrorismo, en cumplimiento de las obligaciones establecidas por la normativa aplicable.</li>
        <li>Los datos personales que autorizo a ser tratados incluyen, pero no se limitan a:
            <ul>
                <li>Nombre completo.</li>
                <li>Número de identificación.</li>
                <li>Dirección de domicilio.</li>
                <li>Información financiera relevante.</li>
                <li>Datos relacionados con transacciones y operaciones financieras.</li>
                <li>Patrimonio.</li>
                <li>Información relativa a Personas Políticamente Expuestas (PEP).</li>
            </ul>
        </li>
        <li>Entiendo que la entidad responsable del tratamiento de datos tiene la obligación legal de tratar mis datos personales con confidencialidad y adoptar todas las medidas técnicas y organizativas necesarias para garantizar su seguridad, integridad y confidencialidad.</li>
        <li>Asimismo, entiendo que mis datos personales podrán ser compartidos con terceros, en la medida en que sea necesario para el cumplimiento de la finalidad antes indicada, siempre dentro de los límites establecidos por la ley.</li>
    </ol></>
    strToyota = <><p>TOYOTA DEL ECUADOR S.A. es el responsable del tratamiento de tus datos personales. Utilizamos tus datos personales, así como los de los terceros relacionados con la
        organización y su estructura societaria (socios, accionistas, directores, apoderados, familiares o empleados),  para ejecutar las acciones necesarias de prevención, detección
        y control de lavado de activos, financiamiento del terrorismo y otros delitos. Estas actividades están basadas en el cumplimiento de obligaciones legales. Tienes derecho a acceder,
        rectificar, actualizar, eliminar u oponerte al uso de tus datos personales, entre otros derechos. Si deseas ejercer alguno de estos derechos o tienes alguna pregunta relacionada
        con la protección de tus datos personales, puedes comunicarte al siguiente correo: dpd@tde.com.ec. Conoce más información sobre el tratamiento de tus datos personales en el
        Aviso de Protección de Datos Personales para Clientes disponible en el siguiente enlace:
        <a href="https://admin-web.toyota.com.ec/uploads/politica_de_proteccion_de_datos_personales_73e37539be.pdf" target="_blank" rel="noopener noreferrer">
        https://admin-web.toyota.com.ec/uploads/politica_de_proteccion_de_datos_personales_73e37539be.pdf</a></p>
        <p>Al completar este formulario, declaras expresamente que has informado previamente a los terceros titulares de quienes proporcionas información sobre la entrega de sus datos
            personales a Toyota del Ecuador, y que entregas todos los datos de este documento debidamente legitimados y de forma lícita.</p></>
    msgAnexo = <>En caso de que el cliente sea  fideicomiso adjuntar al formulario la copia del RUC actualizada, la escritura y su/s adenda/s de ser el caso u otros documentos donde 
        se detalle fideicomitente, fiduciario, beneficiarios, clase de fideicomiso y personas naturales que ejerzan el control efectivo y definitivo sobre este.</>;
}
